import Header from "../../components/Header";
import * as S from "./style";

const Company = () => (
  <>
    <Header />
  </>
);

export default Company;
